import React from 'react';
import { Outlet } from 'react-router-dom';

import { SuspendServiceLayout } from 'layouts';

export const SupervisorNavigator = () => {
  return (
    <SuspendServiceLayout>
      <Outlet />
    </SuspendServiceLayout>
  );
};
